import axios from 'axios';

const maxbo = {

    functionUrl: '/.netlify/functions/maxbo',
    credentials: {

    },
    socreds: 'tst',

    async authorizeVerified(authString, companyId)  {
        let config = this.getConfig('authorizeVerified');
        const body = JSON.stringify({
            authString: authString,
            companyId: companyId
        });
        const response = await axios.post(this.functionUrl, body, config);
        return response;
    },

    async getValues()  {
        let config = this.getConfig('getValues');
        const response = await axios.get(this.functionUrl, config);
        return response;
    },

    async getCustomer(cid, aid, soauth)  {
        let config = this.getConfig('getCustomer');
        config.headers['cid'] = cid;
        config.headers['aid'] = aid;
        config.headers['soauth'] = soauth;
        const response = await axios.get(this.functionUrl, config);
        return response;
    },

    async getShipping(customerNumber)  {
        let config = this.getConfig('getShipping');
        config.headers['cid'] = customerNumber;
        const response = await axios.get(this.functionUrl, config);
        return response;
    },

    async getShippingAndRows(customerNumber)  {
        let config = this.getConfig('getShippingAndRows');
        config.headers['cid'] = customerNumber;
        const response = await axios.get(this.functionUrl, config);
        return response;
    },

    async overwriteShipping(customerNumber, shipping)  {
        let config = this.getConfig('overwriteShipping');
        config.headers['cid'] = customerNumber;
        const body = JSON.stringify(shipping);
        const response = await axios.post(this.functionUrl, body, config);
        return response;
    },

    async getAllRows()  {
        let config = this.getConfig('getAllRows');
        const response = await axios.get(this.functionUrl, config);
        return response;
    },

    async generatePDF(translations, customer, shipping, additionalInfo)  {
                
        let config = this.getConfig('generatePDF');
        let baseUrl = 'https://maxbo-discount-agreements.web.verified.eu//';
        // if (location.hostname === "localhost") baseUrl = 'http://localhost:8888/';
        const body = JSON.stringify({
            path: baseUrl + 'template',
            userdata: {
                customer: customer,
                shipping: shipping,
                translations: translations,
                additionalInfo: additionalInfo
            }
        });
        const response = await axios.post(this.functionUrl, body, config);
        return response;
    },

    getConfig(method) {
        let config = {
            headers: {
                'method': method,
                'socreds': this.socreds,
                'Pragma' : 'no-cache' // IE-fix - disable caching of network calls
            }
        }
        return config;
    },

};
export default maxbo;